module.exports = __webpack_public_path__ + "img/zmlogo.45018774.png";